module.exports = __webpack_public_path__ + "img/myphone_shop_banner_1.584cfd30.jpeg";